import { UseQueryResult } from "@tanstack/react-query";
import { createContext, useContext } from "react";
import { PurchaseOrderContextType } from "../types/PurchaseOrderContextType";
import { PurchaseOrderDetails } from "../types/PurchaseOrderDetails";

enum RefetchScope {
	Files,
	Notes
}

const PurchaseOrderContext = createContext<{
	order: PurchaseOrderContextType,
	modifyOrder: (details: PurchaseOrderDetails) => void
	refetchOrder: (scope?: RefetchScope) => Promise<UseQueryResult>
}>
	({
		order: {} as PurchaseOrderContextType,
		modifyOrder: () => { },
		refetchOrder: (scope?: RefetchScope) => { return new Promise(() => { }); }
	});

const usePurchaseOrder = () => useContext(PurchaseOrderContext);

export { PurchaseOrderContext, usePurchaseOrder, RefetchScope }
